<template>
  <vs-input
    :success="!errors.first(name) && value != ''"
    val-icon-success="done"
    val-icon-danger="error"
    :danger="errors.first(name) ? true : false"
    :name="name"
    :danger-text="errors.first(name)"
    :data-vv-as="name"
    :label="label"
    icon-no-border
    :icon="icon"
    icon-pack="feather"
    class="w-full"
    v-model="internalValue"
  />
</template>

<script>
export default {
  name: 'InputField',
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
